export const EDIT_CONCEPTOS_ESTIMACION = "EDIT_CONCEPTOS_ESTIMACION";
export const EDIT_PARTIDAS_PRECIARIO = "EDIT_PARTIDAS_PRECIARIO";
export const EDIT_CONCEPTOS_EXTRA = "EDIT_CONCEPTOS_EXTRA";
export const EDIT_CONCEPTOS = "EDIT_CONCEPTOS";
export const EDIT_ESIMATION = "EDIT_ESIMATION";
export const CANCEL_EDIT = "CANCEL_EDIT";
export const SET_VIEW = "SET_VIEW";